export default __webpack_public_path__ + "static/media/IMG_2719.7fcf8de5.jpg";